import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  CircleIcon,
  HighlightTextIcon,
  HTMLIcon,
  ImageIcon,
  MediaIcon,
  PencilIcon,
  RectIcon,
  TextIcon,
} from '@readcloud/annotations';
import { Annotation } from '@readcloud/data';
import React from 'react';
import { IconBaseProps } from 'react-icons';

export const IconOfAnnotation: React.FC<
  { type: Annotation['type'] } & Partial<IconBaseProps>
> = (props) => {
  switch (props.type) {
    case 'Media':
      return <MediaIcon {...props} />;
    case 'HTML':
      return <HTMLIcon {...props} />;
    case 'Image':
      return <ImageIcon {...props} />;
    case 'Path':
      return <PencilIcon {...props} />;
    case 'Rectangle':
      return <RectIcon {...props} />;
    case 'Circle':
      return <CircleIcon {...props} />;
    case 'OverlayText':
      // @ts-expect-error
      return <TextIcon {...props} />;
    case 'Text':
      return <HighlightTextIcon {...props} />;
    default:
      return <FontAwesomeIcon icon={'cloud'} size="lg" />;
  }
};
